import React from 'react'

export default function AlertInbox() {
  return (
    <div>AlertInbox</div>
  )
}
